import { formatDateNoTime } from "./util/date";
export const defaultSignatureEmailSubject = "Your signature is requested";
export const defaultSignatureEmailBody = "<p>Your signature is requested. Please click on this link: {{link}}</p>";
export const defaultSignatureCompletionEmailSubject = "Signed document available";
export const defaultSignatureCompletionEmailBody = "<p>Please find your signed document attached.</p>";
export var SignatureFieldType;
(function (SignatureFieldType) {
    SignatureFieldType["Text"] = "Text";
    SignatureFieldType["Checkbox"] = "Checkbox";
    SignatureFieldType["Date"] = "Date";
    SignatureFieldType["Signature"] = "Signature";
    SignatureFieldType["Initial"] = "Initial";
})(SignatureFieldType || (SignatureFieldType = {}));
export var SignatureCheckboxFieldUnicode;
(function (SignatureCheckboxFieldUnicode) {
    SignatureCheckboxFieldUnicode["Checked"] = "\u2611";
    SignatureCheckboxFieldUnicode["Unchecked"] = "\u2610";
})(SignatureCheckboxFieldUnicode || (SignatureCheckboxFieldUnicode = {}));
export const getSignatureCheckboxFieldSymbol = (fieldBooleanValue) => {
    return fieldBooleanValue
        ? SignatureCheckboxFieldUnicode.Checked
        : SignatureCheckboxFieldUnicode.Unchecked;
};
export const formatSignatureFieldValue = (field) => {
    switch (field.fieldType) {
        case SignatureFieldType.Date:
            return formatDateNoTime(field.textValue ?? "", "");
        case SignatureFieldType.Checkbox:
            return getSignatureCheckboxFieldSymbol(field.booleanValue ?? false);
        default:
            return field.textValue ?? "";
    }
};
const breakWordIntoSegments = (word, maxWidth, measureWidth) => {
    const segments = [];
    let current = "";
    for (const char of Array.from(word)) {
        if (current !== "" && measureWidth(current + char) > maxWidth) {
            segments.push(current);
            current = char;
        }
        else {
            current += char;
        }
    }
    if (current !== "") {
        segments.push(current);
    }
    return segments;
};
const wrapParagraphIntoLines = (paragraph, maxWidth, measureWidth) => {
    const lines = [];
    let current = "";
    for (const word of paragraph.split(" ")) {
        const candidate = current === "" ? word : `${current} ${word}`;
        if (measureWidth(candidate) <= maxWidth) {
            current = candidate;
            continue;
        }
        if (current !== "") {
            lines.push(current);
        }
        if (measureWidth(word) <= maxWidth) {
            current = word;
            continue;
        }
        const segments = breakWordIntoSegments(word, maxWidth, measureWidth);
        lines.push(...segments.slice(0, -1));
        current = segments[segments.length - 1] ?? "";
    }
    lines.push(current);
    return lines;
};
export const wrapSignatureFieldText = (text, maxWidth, measureWidth) => {
    if (maxWidth <= 0) {
        return [text];
    }
    return text
        .split("\n")
        .flatMap(paragraph => wrapParagraphIntoLines(paragraph, maxWidth, measureWidth));
};
export const getFieldTypeFontFamily = (fieldType) => {
    switch (fieldType) {
        case SignatureFieldType.Signature:
        case SignatureFieldType.Initial:
            return "'Parisienne', cursive";
        case SignatureFieldType.Checkbox:
            return "'Source Sans Pro', sans-serif";
        default:
            return "'Roboto', sans-serif";
    }
};
export const getFieldTypeFontFilename = (fieldType) => {
    return `${getFieldTypeFontFamily(fieldType)
        .replace(/ /g, "")
        .replace(/'/g, "")
        .split(",")[0]}-Regular.ttf`;
};
//# sourceMappingURL=signature.js.map